import { render, staticRenderFns } from "./UserTagKeysDetails.vue?vue&type=template&id=8a91dbd4&"
import script from "./UserTagKeysDetails.vue?vue&type=script&lang=js&"
export * from "./UserTagKeysDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports